import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'
import type { JobListItem } from '../../types/api'
import Badge from '../../components/ui/Badge'
import Button from '../../components/ui/Button'
import { JobStatusBadge, JobTypeBadge } from '../Jobs'
import SourcingAgentModal from '../../components/SourcingAgentModal'

export default function HeadhunterJobs() {
  const navigate = useNavigate()
  const [jobs, setJobs] = useState<JobListItem[]>([])
  const [loading, setLoading] = useState(true)
  const [sourcingJob, setSourcingJob] = useState<{ id: string; title: string } | null>(null)

  useEffect(() => {
    api.jobs.list()
      .then((res) => setJobs(res.data))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <p className="text-text-muted text-sm">Loading jobs...</p>

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-heading tracking-tactical">ALL JOBS</h1>
      <div className="border border-border-subtle">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border-subtle bg-surface-low">
              <th className="text-left px-4 py-3 text-xs text-text-muted tracking-tactical font-normal">JOB</th>
              <th className="text-left px-4 py-3 text-xs text-text-muted tracking-tactical font-normal hidden md:table-cell">TYPE</th>
              <th className="text-left px-4 py-3 text-xs text-text-muted tracking-tactical font-normal">STATUS</th>
              <th className="text-left px-4 py-3 text-xs text-text-muted tracking-tactical font-normal hidden lg:table-cell">TOPICS</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job) => (
              <tr
                key={job.id}
                className="border-b border-border-subtle hover:bg-surface-low transition-colors"
              >
                <td className="px-4 py-3">
                  <button
                    onClick={() => navigate(`/headhunter/jobs/${job.id}`)}
                    className="text-left hover:text-primary transition-colors"
                  >
                    <p className="font-medium">{job.title}</p>
                    <p className="text-xs text-text-muted">{job.employer}</p>
                  </button>
                </td>
                <td className="px-4 py-3 hidden md:table-cell">
                  <JobTypeBadge type={job.type} />
                </td>
                <td className="px-4 py-3">
                  <JobStatusBadge status={job.status} />
                </td>
                <td className="px-4 py-3 hidden lg:table-cell">
                  <div className="flex flex-wrap gap-1">
                    {job.required_topics.slice(0, 3).map((t) => (
                      <Badge key={t} variant="required">{t}</Badge>
                    ))}
                  </div>
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <Button
                      variant="secondary"
                      onClick={() => setSourcingJob({ id: job.id, title: job.title })}
                      className="text-xs"
                    >
                      RUN SOURCING →
                    </Button>
                    <Button
                      variant="ghost"
                      onClick={() => navigate(`/headhunter/jobs/${job.id}`)}
                      className="text-xs"
                    >
                      VIEW →
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <SourcingAgentModal
        isOpen={sourcingJob !== null}
        onClose={() => setSourcingJob(null)}
        jobId={sourcingJob?.id || ''}
        jobTitle={sourcingJob?.title || ''}
      />
    </div>
  )
}
